import Vue from 'vue';
import Router from "vue-router";

Vue.use(Router);

const templateRegistry = {
  default: { templateId: 'd44055f8-9dac-4386-8a86-bb09f556b87e', version: 2 },
  architects: { templateId: 'b93dd338-6c05-4918-8c54-5b34da80f228', version: 1 }
};

// Generate a whitelist regex from templateRegistry keys (excluding "default")
const allowedIndustries = Object.keys(templateRegistry)
  .filter(key => key !== 'default')
  .join('|');

const routes = [
  // Default health check
  {
    path: '/healthcheck',
    name: 'hc-default',
    component: () => import('./views/HrAuditNew.vue'),
    props: () => templateRegistry.default
  },

  // Industry-specific health check with whitelist regex
  {
    path: `/healthcheck/:industry(${allowedIndustries})`,
    name: 'hc-industry',
    component: () => import('./views/HrAuditNew.vue'),
    props: route => {
      const slug = (route.params.industry || '').toLowerCase();
      return templateRegistry[slug] || templateRegistry.default;
    }
  },

  // Reports by ID
  {
    path: '/report/:id',
    name: 'report',
    component: () => import('./views/HrAudit'),
    props: true
  },

  // Home redirects to default health check
  { path: '/', redirect: { name: 'hc-default' } },

  // Optional: backward compat for old '/:id/' links
  {
    path: '/:id/',
    redirect: to => ({ name: 'report', params: { id: to.params.id } })
  },

   // Catch-all for 404
  {
    path: '*',
    name: 'not-found',
    component: () => import('./views/NotFound.vue')
  }
];

const router = new Router({
  base: '/',
  mode: "history",
  routes
});

export default router;